import {Button, Col, Layout, Row,} from "antd";
import React from "react";
import {Contain} from "@components/layout";
import {Helmet as Head} from "react-helmet-async";
import {useDeleteTokenMutation, useGenerateTokenMutation} from "@services/AccessToken";


const AccessTokensPage = () => {
    const [generateToken, { data }] = useGenerateTokenMutation();
    const [deleteToken] = useDeleteTokenMutation();

    return (
    <Layout className="page">
      <Head>
        <title>Access Tokens</title>
      </Head>
      <Contain>
          <Row justify="space-between">
              <Col>
                  <h2 className="primary-header-color text-left" >
                      The Ultimate Resource for Comic Collectors
                  </h2>
              </Col>
          </Row>
          
        <Row justify="space-between">
            <Col>
                <Button onClick={async () => {
                    const tokenData = await generateToken();
                    console.log('generated token: ', tokenData);
                }}>
                    Generate Token (rtk)
                </Button>
            </Col>
        </Row>

          {data && (
              <Row justify="space-between">
                  <Col>
                      Token: {data.access_token}
                  </Col>
              </Row>
          )}

          <Row justify="space-between">
              <Col>
                  <Button onClick={async () => {
                      const tokenData = await deleteToken();
                      console.log('token deleted: ', tokenData);
                  }}>
                      Delete Token
                  </Button>
              </Col>
          </Row>

      </Contain>
    </Layout>
  );
};

export default AccessTokensPage;
